// landingMarks — the margin marks the "How it lands in …" panel puts on the
// open page while it is open (pen "Tavla · Always writing", scene C): a
// block that changes shape gets arrow-right-left, one not sent eye-off (the
// gutter's ChangeMarker, `landing`); the block pointed at (from the panel's
// rows, Show me, or its mark) is tinted info-bg. An explicit context
// object, provided by the Studio host only while the panel is open (null:
// no marks); the pages read it, nothing else.

export type { LandingMarks };
export { LandingMarksProvider, useLandingMarks };

import { createContext, useContext } from "react";
import type { LandingMark } from "./landingView.js";
import "./HowItLands.css";

type LandingMarks = {
    // By block id on the open page, and by part id among its parts.
    readonly blocks: ReadonlyMap<string, LandingMark>;
    readonly parts: ReadonlyMap<string, LandingMark>;
    // What is pointed at (block or part ids).
    readonly pointed: ReadonlySet<string>;
    readonly onPoint: (ids: readonly string[]) => void;
};

const LandingMarksContext = createContext<LandingMarks | null>(null);
const LandingMarksProvider = LandingMarksContext.Provider;
const useLandingMarks = (): LandingMarks | null =>
    useContext(LandingMarksContext);
